import { FC } from 'react';
import { QcsButton } from '../../../common/basic/QcsButton';
import { QcsDialog } from '../../../common/basic/QcsDialog';
import { QcsDialogActions } from '../../../common/basic/QcsDialogActions';
import { DialogContent as QcsDialogContent, DialogTitle as QcsDialogTitle } from '@mui/material';

import { QcsDialogContentText } from '../../../common/basic/QcsDialogContentText';

import { RepairLineBreaks } from '../../../common/RepairLineBreaks';
import { useInvitation } from './invitationFunctions';
import { InvitedPersonDto } from '@api/models/invitation/InvitedPersonDto';
import { invitationPersonService } from '@api/services/services';
import { ShowError } from '../../../ShowError';
import { resources } from '@api/resources';

interface Props {
  data?: InvitedPersonDto;
  onClose: () => void;
}

export const InvitedPersonsOverride: FC<Props> = ({ data, onClose }) => {
  const { t, invitation, callWithLock, reloadInvitation } = useInvitation();

  const handleConfirm = async () => {
    await callWithLock(async () => {
      await invitationPersonService.overridePersonRequirements(invitation.id!, data!.id!);
      await reloadInvitation();
      onClose();
    });
  };

  return (
    <QcsDialog open={!!data} onClose={onClose}>
      <QcsDialogTitle>{t('invitation.persons.overrideTitle')}</QcsDialogTitle>
      <QcsDialogContent>
        <QcsDialogContentText>
          <RepairLineBreaks text={t('invitation.persons.overrideMessage')} />
        </QcsDialogContentText>
        <ShowError resource={resources.overridePersonRequirements} />
      </QcsDialogContent>
      <QcsDialogActions>
        <QcsButton onClick={onClose} resourceLoading={resources.overridePersonRequirements}>
          {t('common.back')}
        </QcsButton>
        <QcsButton onClick={handleConfirm} resourceLoading={resources.overridePersonRequirements}>
          {t('invitation.persons.overrideConfirm')}
        </QcsButton>
      </QcsDialogActions>
    </QcsDialog>
  );
};
